import { useEffect, useState } from "react";

// 00:17:34 — every countdown on the page shares one start time so they stay in sync,
// and the timer restarts automatically once it reaches zero.
const DURATION_S = 17 * 60 + 34;
const START = Date.now();

function getRemainingSeconds(): number {
  const elapsed = Math.floor((Date.now() - START) / 1000);
  return DURATION_S - (elapsed % (DURATION_S + 1));
}

export function useCountdown() {
  const [remaining, setRemaining] = useState<number>(getRemainingSeconds);

  useEffect(() => {
    const id = window.setInterval(() => setRemaining(getRemainingSeconds()), 250);
    return () => window.clearInterval(id);
  }, []);

  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  const seconds = remaining % 60;

  return {
    hours: String(hours).padStart(2, "0"),
    minutes: String(minutes).padStart(2, "0"),
    seconds: String(seconds).padStart(2, "0"),
  };
}
